import { FunctionComponent, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { WIcon, WLabel } from '@alice-health/wonderland-react'

interface FilterSectionProps {
  title: string
  /** Applied value, shown under the title */
  value?: string
  opened?: boolean
  disabled?: boolean
  onToggle: () => void
}

/**
 * Collapsible row of the mobile filters panel. `w-accordion` does not fit: it
 * shows no value and takes no disabled state.
 */
const FilterSection: FunctionComponent<
  PropsWithChildren<FilterSectionProps>
> = ({
  title,
  value,
  opened = false,
  disabled = false,
  children,
  onToggle
}) => (
  <div className='flex flex-col border-b border-gl-color-shades-gray-20'>
    {/*
      A section header takes `disabled` and `aria-expanded`, which `w-button`
      does not carry, and holds two labels, which `w-helper` does not.
    */}
    {/* eslint-disable-next-line @alice-health/w-button */}
    <button
      type='button'
      className='flex items-center justify-between gap-gl-spacing-04 w-full py-gl-spacing-05 text-left disabled:cursor-not-allowed'
      disabled={disabled}
      aria-expanded={opened}
      onClick={onToggle}
    >
      {/* eslint-disable-next-line @alice-health/w-helper */}
      <span className='flex flex-col'>
        {/* `heavy` e o `Label/Medium Heavy` do handoff: DM Sans SemiBold 14px. */}
        <WLabel
          size='medium'
          variant='heavy'
          mode={disabled ? 'disabled' : 'primary'}
        >
          {title}
        </WLabel>

        {value ? <WLabel mode='secondary'>{value}</WLabel> : null}
      </span>

      <WIcon
        className={classNames(
          'transition-transform duration-200',
          opened && 'rotate-180',
          disabled && 'text-gl-color-shades-gray-30'
        )}
        icon='icChevronArrowDown'
        size='medium'
      />
    </button>

    {opened ? <div className='pb-gl-spacing-05'>{children}</div> : null}
  </div>
)

export { FilterSection }
export type { FilterSectionProps }
